import React from 'react'
import WorkTimeInput from './WorkTimeInput'
import Accordion from 'react-bootstrap/Accordion'


function AllCollapseExample() {
    return (
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header><p>Mehr Details</p></Accordion.Header>
          <Accordion.Body>
  
          <WorkTimeInput />
  
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  }


  export default AllCollapseExample;